import { primitive } from 'styles/constants';
export const DELIVERY_PROGRESS_COLOR = primitive.$fieryRed;
